import { render, staticRenderFns } from "./course-mapping-mitra.vue?vue&type=template&id=82bbdf9a&scoped=true"
import script from "./course-mapping-mitra.vue?vue&type=script&lang=js"
export * from "./course-mapping-mitra.vue?vue&type=script&lang=js"
import style0 from "./course-mapping-mitra.css?vue&type=style&index=0&id=82bbdf9a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bbdf9a",
  null
  
)

export default component.exports